import { LocalStorageService } from 'ngx-webstorage';
var LoaderComponent = /** @class */ (function () {
    function LoaderComponent(localSt) {
        this.localSt = localSt;
    }
    LoaderComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.localSt.observe('loaderSetting').subscribe(function (data) {
            _this.showLoader = data.showLoader;
        });
    };
    return LoaderComponent;
}());
export { LoaderComponent };



// WEBPACK FOOTER //
// ./src/app/modules/shared/loader/loadar.component.ts.pre-build-optimizer.js